import type { AuthStatus } from '@/types/auth'

interface YubiKeyVisualProps {
  status?: AuthStatus
  showTouchIcon?: boolean
  size?: 'sm' | 'md' | 'lg'
}

function YubiKeyVisual({ status, showTouchIcon = false, size = 'md' }: YubiKeyVisualProps) {
  const sizeClasses = {
    sm: 'w-48',
    md: 'w-72',
    lg: 'w-80',
  }

  const shouldPulse = status === 'touching' || status === 'verifying'

  return (
    <div className="relative flex justify-center items-center">
      {/* Background glow */}
      <div
        className={`absolute inset-0 bg-yubico-green-400/20 blur-3xl rounded-full ${shouldPulse ? 'animate-yubikey-pulse' : ''
          }`}
      />

      <div className="relative">
        <img
          src="/assets/images/img-family-lineup.png"
          alt="YubiKey Family Lineup"
          className={`${sizeClasses[size]} h-auto object-contain relative`}
        />

        {/* Touch pulse overlay during touching state */}
        {status === 'touching' && (
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="w-16 h-16 bg-yubico-green-400 rounded-full opacity-30 animate-ping" />
          </div>
        )}

        {/* Success checkmark overlay */}
        {status === 'success' && (
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="w-20 h-20 bg-yubico-green-400 rounded-full flex items-center justify-center animate-success-check">
              <i className="iconoir-check text-white text-4xl font-bold"></i>
            </div>
          </div>
        )}

        {/* Floating touch icon on home page */}
        {showTouchIcon && (
          <div className="absolute -right-12 top-1/2 -translate-y-1/2">
            <i className="iconoir-fingerprint text-yubico-green-400 text-5xl animate-touch-pulse"></i>
          </div>
        )}
      </div>
    </div>
  )
}

export default YubiKeyVisual
